export const DEVICE_WIDTHS = {
  mobile: `375px`,
  tablet: `750px`,
  pdf: `1050px`,
  laptop: `1280px`,
  desktop: `1920px`,
  xl: `2560px`,
}

export const DEVICE = {
  mobile: `(min-width: ${DEVICE_WIDTHS.mobile})`,
  tablet: `(min-width: ${DEVICE_WIDTHS.tablet})`,
  pdf: `(min-width: ${DEVICE_WIDTHS.pdf})`,
  laptop: `(min-width: ${DEVICE_WIDTHS.laptop})`,
  desktop: `(min-width: ${DEVICE_WIDTHS.desktop})`,
  xl: `(min-width: ${DEVICE_WIDTHS.xl})`,
}
